import type { Account } from '@olimhub/shared'

/** Group accounts (Phase B1) link to their /groups/:slug page instead of the generic profile page. */
export function accountPath(account: Pick<Account, 'accountType' | 'groupSlug' | 'username'>): string {
  if (account.accountType === 'group' && account.groupSlug) return `/groups/${account.groupSlug}`
  return `/@${account.username}`
}
